export default __webpack_public_path__ + "static/media/Snd_5_Starts.7740b164.mp3";